import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=3d8316ba&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts&"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=3d8316ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8316ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDivider,VRow,VSpacer,VToolbar,VToolbarTitle})
